import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Sparkles } from 'lucide-react';
import i18n from '../../../i18n';

/**
 * Seller CTA card — "Got an asset to auction?"
 */
export const SellerCtaCard = () => (
    <div className="as-cta-card as-cta-card--seller">
        <div className="as-cta-card__badge">
            <span className="as-cta-card__dot" />
            {i18n.t('for_sellers')}
        </div>
        <h3 className="as-cta-card__title">
            {i18n.t('got_asset_to_auction')}
        </h3>
        <p className="as-cta-card__desc">
            {i18n.t('seller_cta_desc')}
        </p>
        <Link to="/contact" className="as-cta-card__btn">
            {i18n.t('list_your_auction')}
            <ArrowRight size={16} />
        </Link>
    </div>
);

/**
 * Saudi branch CTA card — "Now in Saudi Arabia"
 */
export const SaudiBranchCard = () => (
    <div className="as-cta-card as-cta-card--saudi">
        <div className="as-cta-card__badge as-cta-card__badge--gold">
            <Globe size={12} />
            {i18n.t('new_branch') || 'NEW BRANCH'}
        </div>
        <h3 className="as-cta-card__title">
            {i18n.t('now_in_saudi') || 'Now in Saudi Arabia!'}
        </h3>
        <p className="as-cta-card__desc">
            {i18n.t('saudi_branch_desc') || 'Explore auctions from our new KSA branch. Trusted quality, closer to you.'}
        </p>
        <a href="https://mzadcom.sa" target="_blank" rel="noopener noreferrer" className="as-cta-card__btn">
            {i18n.t('explore_ksa_auctions') || 'Explore KSA auctions'}
            <ArrowRight size={16} />
        </a>
    </div>
);

/**
 * Empty state card — "No auctions live right now"
 */
export const NoAuctionsCard = () => (
    <div className="as-cta-card as-cta-card--empty">
        <div className="as-cta-card__badge as-cta-card__badge--muted">
            <span className="as-cta-card__dot as-cta-card__dot--idle" />
            {i18n.t('live_auctions') || 'LIVE AUCTIONS'}
        </div>
        <h3 className="as-cta-card__title">
            {i18n.t('no_auctions_live') || 'No auctions live right now'}
        </h3>
        <p className="as-cta-card__desc">
            {i18n.t('no_auctions_desc') || 'Check back soon — new auctions drop regularly. Browse by category'}
        </p>
        <div className="as-cta-card__actions">
            <Link to="/auctions" className="as-cta-card__btn">
                {i18n.t('browse_categories') || 'Browse categories'}
                <ArrowRight size={16} />
            </Link>
        </div>
    </div>
);

export const ComingSoonCard = () => (
    <div className="as-cta-card as-cta-card--coming">
        <div className="as-cta-card__badge as-cta-card__badge--gold">
            <Sparkles size={12} />
            {i18n.t('new_feature') || 'NEW FEATURE'}
        </div>
        <h3 className="as-cta-card__title">
            {i18n.t('direct_sale_coming') || 'Direct Sale — Coming Soon!'}
        </h3>
        <p className="as-cta-card__desc">
            {i18n.t('direct_sale_coming_desc') || 'Buy assets instantly at fixed prices — no bidding needed. Be the first to know when it launches.'}
        </p>
        <Link to="/contact" className="as-cta-card__btn">
            {i18n.t('notify_me') || 'Notify me'}
            <ArrowRight size={16} />
        </Link>
    </div>
);